module.exports = __webpack_public_path__ + "static/media/profileHeaderBackground.09e0c40f.png";